/* rv Learn (rv-learn-article, rv-learn-page). Pages read fine without it. Contents (C07): H2s minus the
   evidence / no-claim boxes, hidden below 2 entries, active = last H2 above header + 30 % (RV.onScroll: capture,
   .page-wrapper scrolls from 990 px). Sources (C06): [n] or #source-n opens the box. Lists (C05): role=list.
   Tables: inline script in snippets/rv-learn-tables.liquid. */
(() => {
  const SEL = '[data-rv-section="learn-article"], [data-rv-section="learn-page"]';
  const SKIP = /^(evidence snapshot|what we don[’']t claim|keep reading)\b/i;
  const clean = (t) => t.replace(/\s+/g, ' ').trim();
  const slug = (t) =>
    t.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 64) || 'section';
  const hash = () => {
    try {
      return decodeURIComponent(location.hash.slice(1));
    } catch (e) {
      return '';
    }
  };
  const px = (el) => parseFloat(getComputedStyle(el).getPropertyValue('--rv-header-h'));
  const headerH = (root) => px(root) || px(document.documentElement) || 64;
  const onScroll = (fn) => {
    if (window.RV && window.RV.onScroll) return window.RV.onScroll(fn);
    const o = { capture: true, passive: true };
    document.addEventListener('scroll', fn, o);
    addEventListener('resize', fn);
    return () => {
      document.removeEventListener('scroll', fn, o);
      removeEventListener('resize', fn);
    };
  };

  const toc = (root, body) => {
    const nav = root.querySelector('[data-rv-learn-toc]');
    const list = nav && nav.querySelector('ol');
    if (!list) return;
    const hs = [...body.querySelectorAll('h2')].filter((h) => {
      const t = clean(h.textContent);
      return t && !SKIP.test(t) && !h.closest('.rv-learn-evidence, .rv-learn-callout--noclaim');
    });
    if (hs.length < 2) {
      nav.hidden = true;
      return;
    }
    list.textContent = '';
    const links = hs.map((h) => {
      if (!h.id) {
        const base = 'rv-' + slug(clean(h.textContent));
        let id = base;
        for (let n = 2; document.getElementById(id); n++) id = base + '-' + n;
        h.id = id;
      }
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.className = 'rv-learn-toc__link';
      a.href = '#' + h.id;
      a.textContent = clean(h.textContent);
      li.append(a);
      list.append(li);
      return a;
    });
    nav.classList.add('is-ready');

    const box = nav.querySelector('details');
    const wide = matchMedia('(min-width: 990px)');
    const sync = () => {
      if (box) box.open = wide.matches;
    };
    sync();
    wide.addEventListener('change', sync);

    let hh = headerH(root);
    let cur = -2;
    let raf = 0;
    const update = () => {
      raf = 0;
      const lim = hh + innerHeight * 0.3;
      let i = -1;
      for (let n = 0; n < hs.length && hs[n].getBoundingClientRect().top <= lim; n++) i = n;
      if (i === cur) return;
      cur = i;
      links.forEach((a, n) => (n === i ? a.setAttribute('aria-current', 'true') : a.removeAttribute('aria-current')));
    };
    const queue = (e) => {
      if (e && e.type === 'resize') hh = headerH(root);
      if (!raf) raf = requestAnimationFrame(update);
    };
    const off = onScroll(queue);
    /* Ids are made here: follow a #heading URL now. */
    const id = hash();
    const target = id && hs.find((h) => h.id === id);
    if (target) target.scrollIntoView();
    update();
    return () => {
      wide.removeEventListener('change', sync);
      off();
      if (raf) cancelAnimationFrame(raf);
    };
  };

  const sources = (root) => {
    const box = root.querySelector('[data-rv-learn-sources]');
    if (!box) return;
    const go = (id, scroll) => {
      const el = /^source-\d+$/.test(id) && document.getElementById(id);
      if (!el || !box.contains(el)) return;
      box.open = true;
      if (scroll) el.scrollIntoView();
    };
    const fromHash = () => go(hash(), true);
    const onClick = (e) => {
      const a = e.target.closest && e.target.closest('a[href^="#source-"]');
      if (a) go(a.getAttribute('href').slice(1), false);
    };
    root.addEventListener('click', onClick);
    addEventListener('hashchange', fromHash);
    if (location.hash) fromHash();
    return () => {
      root.removeEventListener('click', onClick);
      removeEventListener('hashchange', fromHash);
    };
  };

  const init = (root) => {
    const body = root.querySelector('[data-rv-learn-body]');
    if (!body) return;
    body.querySelectorAll(':scope > ol:not([class])').forEach((ol) => ol.setAttribute('role', 'list'));
    const offs = [toc(root, body), sources(root)].filter(Boolean);
    return () => offs.forEach((f) => f());
  };

  if (window.RV && window.RV.register) {
    window.RV.register(SEL, init);
    return;
  }
  const run = (scope) => scope.querySelectorAll(SEL).forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run(document));
  else run(document);
  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();
